import { AdminLayoutRoutes } from 'src/app/layouts/admin-layout/admin-layout.routing';
import { Asset } from 'src/app/core/models/opensea/opensea-asset';
import { AssetFilter } from 'src/app/pages/browse/asset-filter';
import { Celebrity } from 'src/app/core/models/celebrity';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConnectWalletComponent } from 'src/app/components/connect-wallet/connect-wallet.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FirebaseService } from 'src/app/core/services/firebase.service';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OpenseaService } from 'src/app/core/services/opensea.service';
import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@Component({
    selector: 'app-heyjom-navbar',
    templateUrl: './heyjom-navbar.component.html',
    styleUrls: ['./heyjom-navbar.component.scss']
})
export class HeyjomNavbarComponent implements OnInit {
    isConnected = false;
    walletAddress;
    walletBalance: number;
    isDrop = false;
    isSearch = false;
    control = new FormControl();
    creatorResults: any;
    assets: Asset[];
    collectiblesResults: Asset[];
    params = new AssetFilter();
    celebrities: Celebrity[];
    celebritiesResults: Celebrity[];
    heyJomDesktopLogo: string;
    heyJomMobileLogo: string;

    @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger }) autoComplete: MatAutocompleteTrigger;

    constructor(
        private location: Location,
        private router: Router,
        private openseaService: OpenseaService,
        private modalService: NgbModal,
        private firebaseService: FirebaseService,
        private popupService: PopupService,
        private activatedRoute: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.openseaService.getAccount().then(response => {
            this.isConnected = response.result.length > 0 ? true : false;
            this.walletAddress = this.truncateAddressText();
        }).finally(() => {
            if (this.isConnected) {
                this.openseaService.getBalance().then(response => {
                    this.walletBalance = response;
                });
            }
        });

        this.getCelebrity();
        this.getAssets();
        this.getCampaignLogo();

        this.control.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
            .subscribe(() => {
                return this.filterCelebrity(this.control.value);
            });

        this.control.valueChanges.pipe(debounceTime(100), distinctUntilChanged())
            .subscribe(() => {
                return this.filterAssets(this.control.value);
            });
    }

    getTitle() {
        let url = this.location.prepareExternalUrl(this.location.path());

        if (url.charAt(0) === '#') {
            url = url.slice(2);
        }

        // TODO: macam no need.
        const route = AdminLayoutRoutes.find(r => r.path == url);

        return route && route.data ? route.data.title : null;
    }

    getCelebrity() {
        this.firebaseService.getCelebrityListingByCategory('All').subscribe(response => {
            this.celebrities = response;
            this.celebrities.map(celebrity => {
                this.firebaseService.getImageUrl(celebrity.profilePicture).subscribe(url => {
                    celebrity.profilePicture = url;
                });
            })
        })
    }

    filterCelebrity(searchText: string): Celebrity[] {
        if (this.celebrities) {
            this.celebritiesResults = this.celebrities.filter(celebrity => {
                return celebrity.name.toLowerCase().includes(searchText.toLowerCase());
            })
        } else {
            return [];
        }
    }

    getAssets() {
        this.params.limit = 50;
        this.openseaService.getAssetsHttp(this.params).subscribe(response => {
            this.assets = response.assets.map(e => { return new Asset(e) });
        })
    }

    filterAssets(searchText: string): Asset[] {
        if (this.assets) {
            this.collectiblesResults = this.assets.filter(asset => {
                return asset.name.toLowerCase().includes(searchText.toLowerCase());
            });
        }
        else {
            return [];
        }
    }

    routeToPage(url, isRelative: boolean = false) {
        let extra: NavigationExtras = {};
        if (isRelative === true) {
            extra = { relativeTo: this.activatedRoute };
        }

        this.isDrop = false;
        this.router.navigate([url], extra);
    }

    truncateAddressText() {
        let str = this.openseaService.getWalletAddress();
        return str.substr(0, 6) + '...' + str.substr(str.length - 4, str.length)
    }

    connectWallet() {
        this.openModal().then(result => {
        });
    }

    mobileCloseDrop() {
        this.isSearch = false;
        this.isDrop = false;
    }

    private openModal(): Promise<any> {
        let defaultOptions: any = {
            size: 'sm',
            backdrop: 'static',
            centered: true,
            keyboard: false,
            windowClass: 'connect-modal-popup',
            backdropClass: 'connect-backdrop-popup',
        };

        const modalRef = this.modalService.open(ConnectWalletComponent, defaultOptions);

        return modalRef.result;
    }

    private getCampaignLogo(): void {
        this.firebaseService.getCampaignLogo().subscribe(
            (heyJomLogo) => {
                this.firebaseService.getImageUrl(heyJomLogo.desktop).subscribe(
                    (imgUrl) => {
                        this.heyJomDesktopLogo = imgUrl;
                    },
                    (err) => { console.error(err); },
                );

                this.firebaseService.getImageUrl(heyJomLogo.mobile).subscribe(
                    (imgUrl) => {
                        this.heyJomMobileLogo = imgUrl;
                    },
                    (err) => { console.error(err); },
                );
            },
            (err) => { console.error(err); },
        );
    }
}
